export default __webpack_public_path__ + "552a60b185d56eb823b0ef683f27fa0e.jpg";